<template>
    <div class="coverdetailsbloc">
         <span class="info-title">{{$t('Claim.RequestClaim.SUMMARY_CLAIM_COVER_SUB_TITLE')}}</span>
        <div class="divider">
            <v-divider></v-divider>
        </div>
        <div class="detailsinfoclaim" style="padding-bottom: 22px !important;">
                <span class="sub-title-header">{{$t('Claim.RequestClaim.SUMMARY_FILE_ATTACHMENT_SUB_TITLE')}}</span>
        </div>
        <v-layout v-for="(item, index) in submittedClaim.documents" :key="index" row class="submitclaimfilesfield">
          <span >{{item.fileTitle}}</span>
          <UploadedDocumentList :files="item.files" :title="item.fileTitle"/>
        </v-layout>
        <ContactDetails :contact="submittedClaim.buyer" :title="buyerContactTitle" />
        <ContactDetails v-if="claimExtendedForm" :contact="submittedClaim.seller" :title="sellerContactTitle" />
        <div class="detailsinfoclaim">
                <span class="sub-title-header">{{$t('Claim.RequestClaim.SUMMARY_CONTEXT_INFORMATION_SUB_TITLE')}}</span>
        </div>
        <v-layout v-if="showCollectedAmount" row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.ShowClaim.COLLECTED_AMOUNT_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{submittedClaim.collectedAmount}} {{currency}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.ShowClaim.AMOUNT_WITHOUT_VAT_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{submittedClaim.amountWithoutVAT}} {{currency}}
                </v-flex>
        </v-layout>
        <v-layout v-if="showDeliveryDate" row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>Delivery date</v-label>
                </v-flex>
                <v-flex xs6>
                    {{deliveryDate}}
                </v-flex>
        </v-layout>
        <v-layout v-if="claimExtendedForm" row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.ShowClaim.FUNDED_AMOUNT_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{submittedClaim.fundedAmount}} {{currency}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_IS_INVOICE_DISPUTED_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{submittedClaim.invoicedisputed === 'Yes' ? $t('Claim.RequestClaim.SUMMARY_YES_DESC') : $t('Claim.RequestClaim.SUMMARY_NO_DESC')}}
                </v-flex>
        </v-layout>
         <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_IS_BUYER_UNDER_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{submittedClaim.buyerinsolvency === 'Yes' ? $t('Claim.RequestClaim.SUMMARY_YES_DESC') : $t('Claim.RequestClaim.SUMMARY_NO_DESC')}}
                </v-flex>
        </v-layout>
         <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_REFERENCE_NUMBER_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{submittedClaim.clientRefNumber}}
                </v-flex>
        </v-layout>
        <v-layout row class="detailfieldinfo companydetailscontent">
                <v-flex xs6>
                    <v-label>{{$t('Claim.RequestClaim.SUMMARY_COMMENT_FIELD_NAME')}}</v-label>
                </v-flex>
                <v-flex xs6>
                    {{submittedClaim.comment}}
                </v-flex>
        </v-layout>

    </div>
</template>
<script>
import { mapState } from 'vuex'
import UploadedDocumentList from '@/components/common/UploadedDocumentList'
import ContactDetails from '@/components/cover/claim/ContactDetails'

export default {
  data () {
    return {
      buyerContactTitle: this.$t('Claim.RequestClaim.SUMMARY_BUYER_CONTACT_SUB_TITLE'),
      sellerContactTitle: this.$t('Claim.ShowClaim.SELLER_CONTACT_SUB_TITLE'),
      claimExtendedForm: false,
      showCollectedAmount: false,
      showDeliveryDate: false,
      currency: ''
    }
  },
  computed: {
    deliveryDate: function () {
      if (this.submittedClaim && this.submittedClaim.deliveryDate) {
        return this.$formatDateFromUniversal(this.submittedClaim.deliveryDate)
      }
      return ''
    },
    ...mapState('cover', ['cover', 'submittedClaim']),
    ...mapState('userdetails', ['userInfos'])
  },
  mounted () {
    this.claimExtendedForm = this.userInfos.claimExtendedForm
    this.showCollectedAmount = this.userInfos.claimSettings.showCollectedAmount
    this.showDeliveryDate = this.userInfos.claimSettings.showDeliveryDate
    this.currency = this.cover.invoice.currency
  },
  components: {
    UploadedDocumentList,
    ContactDetails
  }
}
</script>
<style>
.detailsinfoclaim {
    padding-top: 26px;
}
</style>
